import React from 'react';
import PropTypes from 'prop-types';
import NoSearchResults from '../NoSearchResults';
import Table from '../Table';
import {useEmptyDetails} from '../../hooks';

const EmptyOrTable = ({
  data,
  empty,
  loading,
  query,
  columns,
  tableProps
}) => {
  const { emptyDetails, isEnabledEmpty } = useEmptyDetails({ data, empty, loading, query });

  if (isEnabledEmpty) return empty;

  return (
    <>
      {emptyDetails.enabled ? (
        <NoSearchResults
          spinning={loading}
          value={emptyDetails.text}
        />
      ) : (
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          rowKey='id'
          {...tableProps}
        />
      )}
    </>
  );
};

EmptyOrTable.propTypes = {
  data: PropTypes.array,
  empty: PropTypes.any,
  loading: PropTypes.bool,
  query: PropTypes.object,
  columns: PropTypes.array,
  tableProps: PropTypes.object,
};

export default EmptyOrTable;

